<template>
  <b-row class="pagination-row">
    <b-col
      cols="12"
      md="4"
      sm="4"
      class="form-inline justify-content-center justify-content-sm-start mb-1 mb-md-0"
    >
      <p class="mb-0 p-gray text-nowrap">
        แสดงรายการ
        <span id="from-row">{{
          rows == 0 ? 0 : ((filter.page - 1) * filter.take + 1) | numeral("0,0")
        }}</span>
        ถึง
        <span id="to-row">
          {{
            filter.take * filter.page > rows
              ? rows
              : (filter.take * filter.page) | numeral("0,0")
          }}</span
        >
        จากทั้งหมด <span id="total-row">{{ rows | numeral("0,0") }}</span> รายการ
      </p>
    </b-col>
    <b-col
      cols="12"
      md="8"
      sm="8"
      class="form-inline justify-content-center justify-content-sm-end"
      style="line-height: 0.2"
    >
      <b-pagination
        v-model="filter.page"
        :total-rows="rows"
        :per-page="filter.take"
        @change="$emit('pagination', $event)"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
        class="mb-0"
      ></b-pagination>
      <div class="break"></div>
      <br />
      <div class="mt-1 mt-md-0 ml-0 ml-sm-1" v-if="!hideTake">
        <b-form-select
          class="page-take"
          v-model="filter.take"
          @change="$emit('handleChangeTake', $event)"
          :options="pageOptions"
        ></b-form-select>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    limit: {
      require: false,
      type: Number,
      default: 5,
    },
    filter: {
      required: true,
      type: Object,
    },
    pageOptions: {
      required: false,
      type: Array,
      default: () => {
        return [
          { value: 5, text: "5 / หน้า" },
          { value: 10, text: "10 / หน้า" },
          { value: 30, text: "30 / หน้า" },
          { value: 50, text: "50 / หน้า" },
          { value: 100, text: "100 / หน้า" },
        ];
      },
    },
    handleChangeTake: {
      required: false,
    },
    rows: {
      required: false,
    },
    pagination: {
      required: false,
    },
    hideTake: {
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@media screen and (min-width: 667px) and (max-width: 768px) {
  .pagination-row {
    text-align: center;
    div {
      justify-content: center !important;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
@media only screen and (max-width: 820px) and (min-width: 668px) {
  .page-take {
    max-width: 60px;
  }
}
</style>
